import { TextCell } from '@components/ui/TextCell';
import humanizeDuration from 'humanize-duration';
import { useTranslation } from 'react-i18next';

export type TimestampCellProps = {
  timestamp: string | number | Date | undefined;
};

const diffToNow = (date: number | Date | string, language: string): string => {
  const parsedDate = +new Date(date);
  return humanizeDuration(Date.now() - parsedDate, { round: true, language, largest: 1 });
};

export const TimestampCell = ({ timestamp }: TimestampCellProps): JSX.Element => {
  // useTranslation lived in diffToNow, which only ran when `timestamp` was set -- a conditional hook call.
  const { i18n } = useTranslation();

  return <TextCell text={timestamp ? diffToNow(timestamp, i18n.language) : null} />;
};
